import React, { Component } from "react";
import outside from "../../../../media/reduced-images/outside-straight.jpg";
import Helmet from "react-helmet";
import { Icon } from "@material-ui/core";

import styles from "./ContactUs.module.scss";

class ContactUs extends Component {
  render() {
    const headerImageProps = {
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundImage: `url(${outside})`
    };

    return (
      <div id={styles.container}>
        <Helmet>
          <title>Contact Us</title>
          <meta
            name="description"
            content="
            Get in touch with us to discuss your contract manufacturing needs."
          />
        </Helmet>
        <div id={styles.titleImage} style={headerImageProps}>
          <div id={styles.titleText}>Contact Us</div>
        </div>
        <div id={styles.contactContainer}>
          <div id={styles.contactMethods}>
            <div id={styles.contactHeader}>Reach Out To Us!</div>
            <div className={styles.contactInfo}>
              <Icon className={styles.icons}>phone</Icon>
              215-230-3324 x100 (all inquiries)
            </div>
            <div className={styles.contactInfo}>
              <Icon className={styles.icons}>print</Icon>
              215-230-3328
            </div>
            <div className={styles.contactInfo}>
              <Icon className={styles.icons}>email</Icon>
              michael.austin@powdersolutions.com
            </div>
            <div className={styles.contactInfo}>
              <Icon className={styles.icons}>place</Icon>
              98 Spring Lake Drive New Britain, PA 18901
            </div>
          </div>
        </div>
        <iframe
          id={styles.map}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3043.061668232697!2d-75.18607010649255!3d40.29658967282437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6a7bbe0187d91%3A0xf33aea2ba701f583!2sPowder+Solutions%2C+Inc!5e0!3m2!1sen!2sus!4v1553607407862"
        />
      </div>
    );
  }
}

export default ContactUs;
